import { CheckboxValueType } from "antd/lib/checkbox/Group";
import axios from "axios";

//类型：0教师、1学生
export enum ReceiverType {
    Teacher = "0",
    Student = "1"
}

//会话类型：0一对一会话、1群聊会话
export enum SessionType {
    One = "0",
    More = "1"
}

export enum MsgType {
    TEXT = "text",
    FILE = "file"
}

interface ContactListItem {
    courseNo: string; //关联课程编号
    courseSeq: string; //关联课程序号
    batchNo: string; //学期编号
    costumerCode: string; //用户代码
    courseName: string; //课程名称
    chatContacts: {
        no: string; //联系人编号;
        name: string; //联系人姓名;
    }[]; //私信联系人列表
}

/**
 * 获取学生联系人列表信息
 */
export function getContactList(name?: string) {
    return axios
        .post<SuccessData<ContactListItem[]>>("/teacher/chat/getContactList", {
            name: name?.trim()
        })
        .then(res => res.data.data)
        .then(data => {
            return data?.map(item => ({
                title:
                    item.courseName + ` （${item.courseNo}-${item.courseSeq}）`,
                key: item.courseNo + item.courseSeq,
                value: item.courseNo + item.courseSeq,
                disabled: true,
                children: item.chatContacts?.map(contacts => ({
                    title: contacts.name + ` - ${contacts.no}`,
                    key: contacts.no + "-" + contacts.name,
                    value: contacts.no
                }))
            }));
        });
}

interface ChatConfereesItem {
    no: string; //参与人编号
    name: string; //参与人姓名
    type: ReceiverType; //参与人类型0教师、1学生
    chatStatus?: string; //打开状态：0否1是
}

export interface ChatMessageItem {
    guid: string; //消息guid
    sessionUid: string; //会话guid
    sender: ChatConfereesItem; //发送人信息
    sendDate: string; //发送时间
    courseNo?: string; //关联课程编号
    courseSeq?: string; //关联课程序号
    batchNo?: string; //学期编号
    customerCode?: string; //用户代码
    operatorType: string; //操作类型：0正常显示操作、1撤回操作
    deleteNoTypes?: string; //删除人标识
    content: string; //消息内容
    type: MsgType; //消息类型：text：文本   file：文件
    delStatus: string; //删除标识符（0否1是）
}

interface openSessionItem {
    sessionTopic: string; //会话标题
    guid: string; //会话guid
    chatConferees: ChatConfereesItem[]; //会话参与人
    chatConfereesNoTypeListStr: string; //参会者编号以及类型列表， 用,号隔开
    sessionType: string; //会话类型：0一对一会话、1群聊会话
    hasMsg: string; //是否存在消息：0否1是
    readStatus: string; //已读状态：0未读 1已读
    lastSessionTime: string; //最后会话时间
    chatMessages: ChatMessageItem[]; //消息记录
}

interface openSessionParams {
    guid: string; //会话的guid
    chatConferees: ChatConfereesItem[]; //会话参与人列表
    sessionType: SessionType; //会话类型：0一对一会话、1群聊会话
}

/**
 * 打开会话
 * @param data
 */
export function openSession(data: openSessionParams) {
    return axios
        .post<SuccessData<openSessionItem>>("/teacher/chat/openSession", {
            ...data
        })
        .then(res => res.data.data);
}

export interface SessionListItem {
    sessionTopic: string; //会话标题
    guid: string; //会话guid
    chatConferees: ChatConfereesItem[]; //会话参与人列表
    chatConfereesNoTypeListStr: string; //参会者编号以及类型列表， 用,号隔开
    notReadNoTypeList?: string[]; //还未读取的用户编号+"-"+用户类型（0教师、1学生）
    sessionType: string; //会话类型：0一对一会话、1群聊会话
    hasMsg: string; //是否存在消息：0否1是
    lastSessionTime: string; //最后会话时间
    chatMessages: ChatMessageItem[]; //消息记录
}

/**
 * 查询会话列表
 */
export function getSessionList() {
    return axios
        .post<SuccessData<SessionListItem[]>>("/teacher/chat/findSessionList")
        .then(res => res.data.data);
}

export function closeSession(guid?: string) {
    return axios.get(`/teacher/chat/closeSession/${guid}`);
}

export function findSessionList(sessionUid?: string) {
    return axios
        .get<SuccessData<ChatMessageItem[]>>(
            `/teacher/chat/getSessionMessage/${sessionUid}`
        )
        .then(res => res.data.data);
}

export interface CourseListItem {
    batchNo: string; //课程所属学期
    courseName: string; //课程名称
    courseNo: string; //课程编号
    customerCode: string; //用户代码
    courseSeq: string; //课程序号
    key: string;
}

/**
 * 获取课程列表
 * @param no
 * @param type
 * @returns
 */
export function getCourseList(no: string, type: string) {
    return axios
        .post<SuccessData<CourseListItem[]>>(`/teacher/chat/getCourseList`, {
            no,
            type
        })
        .then(res => res.data.data)
        .then(data =>
            data.map(item => ({
                ...item,
                key: item.courseNo + item.courseSeq
            }))
        );
}

/**
 * 设置已读
 */
export function setHasRead(data: CheckboxValueType[]) {
    return axios.post(`/teacher/chat/setHasRead`, data);
}

/**
 * 删除聊天记录
 * @param sessionUid 会话guid
 * @param guid 消息guid
 * @returns
 */
export function deleteMessage(sessionUid: string, guid: string) {
    return axios.post(`/teacher/chat/deleteMessage`, { sessionUid, guid });
}

/**
 * 批量关闭会话
 */
export function closeSessionBatch(data: CheckboxValueType[]) {
    return axios.post(`/teacher/chat/closeSessionBatch`, data);
}

/**
 * 查询聊天记录
 */
export function findHistoryMsg(
    sessionUid: string,
    type?: "text" | "file",
    content?: string
) {
    return axios
        .post<SuccessData<ChatMessageItem[]>>(`/teacher/chat/findHistoryMsg`, {
            sessionUid,
            type,
            content
        })
        .then(res => res.data.data);
}

/**
 * 获取某个会话的信息
 * @param sessionId
 */
export async function getSessionInfo(sessionId: string) {
    const sessions = await getSessionList();
    return sessions.find(item => item.guid === sessionId);
}

export interface Files {
    fileName: string;
    filePercent: number;
    fileSize: string;
    fileState: "uploading" | "done" | "error" | "pending" | "stop";
    fileType: string;
    fileUrl: string;
    uid: string;
}
